import { TableHeader } from '../../commons'
import InfiniteLoader from '../../commons/InfiniteLoader/InfiniteLoader';
import ScrollToTop from '../../commons/ScrollToTop';
import EmailersTableData from './EmailersTableData';
import { EMAILERS_HEADERS } from '../../../constant/tableHeadersConstants/masterDataContants/masterDataEmailersConst';
import { MasterEmailerList } from '../../../redux/masterData/masterTypes';

type AppProps = {
    fetching: boolean;
    offset: number;
    data: MasterEmailerList[]|[];
    handleEditMasterEmailer: (data: MasterEmailerList) => void;
    handleChangeStatus:(data:MasterEmailerList)=>void;
    isUpdateEmailPresent:boolean;
    
    
}

const EmailersTable = ({
    fetching,
    offset,
    data,
    handleEditMasterEmailer,
    handleChangeStatus,
    isUpdateEmailPresent
}: AppProps) => {

    return (
        <div className='jobsType'>
            <table className="table thead-light table-bordered">
                <thead className='text-start sticky-table-header'>
                    <TableHeader
                        tableHeader={EMAILERS_HEADERS}
                    />
                </thead>
                <tbody>
                    <EmailersTableData
                        data={data}
                        tableHeader={EMAILERS_HEADERS}
                        handleChangeStatus={handleChangeStatus}
                        handleEditMasterEmailer={handleEditMasterEmailer}
                        isUpdateEmailPresent={isUpdateEmailPresent}
                    />
                    {fetching && offset > 0 && <div>{<InfiniteLoader />}</div>}
                    <div style={{ display: fetching ? "none" : "inline" }}>
                        <ScrollToTop />
                    </div>
                </tbody>
            </table>
        </div>
    )
}

export default EmailersTable